// extracted by mini-css-extract-plugin
module.exports = {"btnClear":"InputFileClear_btnClear__1HyyG","btnClearErr":"InputFileClear_btnClearErr__tU62L"};